// extracted by mini-css-extract-plugin
export default {"booking-review-desc-wrapper":"booking-review-desc-wrapper_NGZxw","button-group":"button-group_yUoUb","timeline":"timeline_oEmQb"};